const SELECTOR_BEWERTUNGEN_OVERLAY = ".bewertungen-overlay";
const SELECTOR_BUTTON_CLOSE_OVERLAY = ".button-close-overlay";
const SELECTOR_BEWERTUNGEN_CONTAINER = ".bewertungen-container";
const SELECTOR_BUTTON_WEITERE_ANZEIGEN = ".button-weitere-anzeigen";
const SELECTOR_FILTER_CONTAINER = ".filter-container";
const SELECTOR_TOTAL_ELEMENTS = ".bewertungen-total-elements";

const CLASS_HIDDEN = "hidden";

const STATE_MORE = "more";
const STATE_LESS = "less";

const EVENT_FILTER_AND_SORT_CHANGED = 'bewertungen-artikeldetail-overlay-filter-changed';
const EVENT_OPEN_BEWERTUNGEN_ADS_OVERLAY = 'open-bewertungen-artikeldetail-overlay';
const EVENT_BEWERTUNGEN_ADS_OVERLAY_LOADED = 'bewertungen-artikeldetail-overlay-loaded';
const EVENT_FILTER_AND_SORT_SELECTED = 'bewertungen-artikeldetail-filter-and-sort-selected';
const EVENT_BEWERTUNG_WEITERLESEN = 'bewertung-weiterlesen';

const INCLUDE_URL = '/include/artikelbewertung/artikel';

const DEFAULT_FILTER_AND_SORT = new Map([
    ['s', new Set()],
    ['f', new Set()],
    ['sort', new Set(['RELEVANZ'])]
]);

class BewertungenArtikeldetailOverlay extends HTMLElement {

  connectedCallback() {
    this.setElements();
    this.bindEvents();
    this.initPageStatus();

    this.bewertungSeiteUrlSuffix = this.dataset.buchhaendler === "true" ? "buchhaendler" : "kunde";
  }

  initPageStatus() {
    this.filterContainer.innerHTML = "";
    this.bewertungenContainer.innerHTML = "";
    this.nextPage = 0;
    this.totalElements = null;
    this.zielBewertungId = null;
    this.initialLoad = true;
    this.bewertungenLoaded = false;
    this.filterLoaded = false;
    this.filterAndSort = DEFAULT_FILTER_AND_SORT
    this.setElementVisible(this.buttonWeitereAnzeigen, false);
  }

  setElements() {
    this.bewertungenOverlay = this.querySelector(SELECTOR_BEWERTUNGEN_OVERLAY);
    // this.buttonCloseOverlay = this.querySelector(SELECTOR_BUTTON_CLOSE_OVERLAY);
    this.bewertungenContainer = this.querySelector(SELECTOR_BEWERTUNGEN_CONTAINER);
    this.buttonWeitereAnzeigen = this.querySelector(SELECTOR_BUTTON_WEITERE_ANZEIGEN);
    this.filterContainer = this.querySelector(SELECTOR_FILTER_CONTAINER);
    this.totalElementsSpan = this.querySelector(SELECTOR_TOTAL_ELEMENTS);
  }

  bindEvents() {
    this.buttonWeitereAnzeigen.addEventListener('click', () => this.onWeitereAnzeigenButtonClicked());
    this.bewertungenOverlay.addEventListener('close', () => this.onOverlayClose());

    // RED-12573: Direkter "Weiterlesen"-Klick im Overlay klappt nur diese Karte aus (kein Scroll)
    this.bewertungenContainer.addEventListener(EVENT_BEWERTUNG_WEITERLESEN, event =>
        event.target.closest('bewertung-review-card')?.zeigeVollstaendigenText());

    document.addEventListener(EVENT_FILTER_AND_SORT_CHANGED, event => this.onFilterAndSortChanged(event));
    document.addEventListener(EVENT_OPEN_BEWERTUNGEN_ADS_OVERLAY, event => this.onOpenBewertungenAdsOverlay(event.detail));
  }

  onOpenBewertungenAdsOverlay(detail) {
    if (detail.buchhaendler === (this.dataset.buchhaendler === "true")) {
      // RED-12573: Ziel-Bewertung aus dem Slider merken, um sie nach dem Öffnen anzusteuern
      this.zielBewertungId = detail.bewertungId ?? null;
      if (detail.sterne) {
        this.filterAndSort = this.getDefaultFilterAndSortWithSterne(detail.sterne);
      }
      this.loadFilter();
      this.loadBewertungen();
    }
  }

  getDefaultFilterAndSortWithSterne(sterne) {
    return new Map([
      ['s', new Set([sterne])],
      ['f', new Set()],
      ['sort', new Set(['RELEVANZ'])]
    ]);
  }


  onOverlayClose() {
    this.initPageStatus();
  }

  loadBewertungen() {
    this.setButtonWeitereAnzeigenLoadingState(true);

    fetch(this.getBewertungSeiteUrl())
        .then(response => {
          if (!response.ok) {
            throw response;
          }
          return response.text();
        })
        .then(text => this.onBewertungSeiteReceived(text))
        .catch(error => console.log(error))
        .finally(() => this.setButtonWeitereAnzeigenLoadingState(false));
  }

  onBewertungSeiteReceived(text) {
    const responseHtml = document.createElement("bewertung-seite");
    responseHtml.innerHTML = text;

    if (this.nextPage === 0) {
      this.bewertungenContainer.innerHTML = "";
    }

    const pageElement = responseHtml.firstElementChild;

    // RED-12734: Defense-in-Depth – leerer Response-Body darf nicht auf null.dataset crashen
    if (!pageElement) {
      this.nextPage = null;
      this.setElementVisible(this.buttonWeitereAnzeigen, false);
      this.bewertungenLoaded = true;
      this.openBewertungenOverlay();
      return;
    }

    const nextPage = pageElement.dataset.nextPage;

    this.nextPage = nextPage ? nextPage : null;
    this.setElementVisible(this.buttonWeitereAnzeigen, this.nextPage);

    // RED-12573: Headline-Anzahl auf gefilterte Gesamtzahl der aktuellen Seite setzen
    this.updateTotalElements(pageElement.dataset.totalElements);

    Array.from(pageElement.children).forEach(bewertung => this.bewertungenContainer.appendChild(bewertung));
    this.bewertungenLoaded = true;

    this.openBewertungenOverlay();
  }

  loadFilter() {
    fetch(this.getFilterUrl())
        .then(response => {
          if (!response.ok) {
            throw response;
          }
          return response.text();
        })
        .then(text => this.onFilterReceived(text))
  }

  onFilterReceived(text) {
    const responseHtml = document.createElement("bewertung-filter");
    responseHtml.innerHTML = text;

    this.filterContainer.appendChild(responseHtml);
    this.filterLoaded = true;

    document.dispatchEvent(new CustomEvent(EVENT_FILTER_AND_SORT_SELECTED, { detail: { buchhaendler: this.dataset.buchhaendler, filterAndSort: this.filterAndSort } }));

    this.openBewertungenOverlay();
  }

  openBewertungenOverlay() {
    if (this.initialLoad && this.bewertungenLoaded && this.filterLoaded) {
      if (!this.bewertungenOverlay.hasAttribute("open")) {
        this.bewertungenOverlay.showModal();
      }

      // RED-12573: Overlay ist jetzt offen und die Liste im DOM – ggf. Ziel-Karte ansteuern
      this.zielBewertungAusklappen();

      this.initialLoad = false;
      document.dispatchEvent(new CustomEvent(EVENT_BEWERTUNGEN_ADS_OVERLAY_LOADED, { detail: { buchhaendler: this.dataset.buchhaendler } }));
    }
  }

  // RED-12573: Aus dem Slider angesteuerte Karte ausklappen, in den Blick scrollen und fokussieren
  zielBewertungAusklappen() {
    if (!this.zielBewertungId) {
      return;
    }

    const card = this.bewertungenContainer.querySelector(`[data-bewertung-id="${this.zielBewertungId}"]`);
    if (card) {
      card.zeigeVollstaendigenText();
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // A11y: Fokus folgt dem Sprung – scrollIntoView allein bewegt den Fokus nicht
      card.setAttribute('tabindex', '-1');
      card.focus({ preventScroll: true });
    }

    this.zielBewertungId = null;
  }

  getBewertungSeiteUrl() {
    if (this.dataset.werkId) {
      return `${INCLUDE_URL}/${this.dataset.matNr}/werk/${this.dataset.werkId}/${this.bewertungSeiteUrlSuffix}/bewertungseite${this.getQueryParameter()}`;
    } else {
      return `${INCLUDE_URL}/${this.dataset.matNr}/${this.bewertungSeiteUrlSuffix}/bewertungseite${this.getQueryParameter()}`;
    }
  }

  getFilterUrl() {
    if (this.dataset.werkId) {
      return `${INCLUDE_URL}/${this.dataset.matNr}/werk/${this.dataset.werkId}/${this.bewertungSeiteUrlSuffix}/filter`;
    } else {
      return `${INCLUDE_URL}/${this.dataset.matNr}/${this.bewertungSeiteUrlSuffix}/filter`;
    }
  }

  getQueryParameter() {
    let queryParameter = '?page=' + this.nextPage;

    const sterne = this.filterAndSort.get('s');
    if (sterne.size > 0) {
      queryParameter += ('&s=' + Array.from(sterne).join());
    }

    const formate = this.filterAndSort.get('f');
    if (formate.size > 0) {
      queryParameter += ('&f=' + Array.from(formate).map(format => encodeURIComponent(format)).join());
    }

    queryParameter += '&sort=' + Array.from(this.filterAndSort.get('sort'))[0];

    return queryParameter;
  }

  updateTotalElements(totalElements) {
    if (this.totalElementsSpan && totalElements != null) {
      this.totalElements = totalElements;
      this.totalElementsSpan.textContent = totalElements;
    }
  }

  setElementVisible(element, visible) {
    if (visible) {
      element.classList.remove(CLASS_HIDDEN);
    } else {
      element.classList.add(CLASS_HIDDEN);
    }
  }

  onWeitereAnzeigenButtonClicked() {
    this.loadBewertungen();
  }

  setButtonWeitereAnzeigenLoadingState(isLoading) {
    if (isLoading) {
      this.buttonWeitereAnzeigen.dataset.loading = true;
      this.buttonWeitereAnzeigen.disabled = true;
    } else {
      this.buttonWeitereAnzeigen.removeAttribute('data-loading');
      this.buttonWeitereAnzeigen.removeAttribute('disabled');
    }
  }

  onFilterAndSortChanged(event) {
    if (event.detail.buchhaendler === (this.dataset.buchhaendler === "true") && this.bewertungenOverlay.hasAttribute("open")) {
      this.filterAndSort = event.detail.filterAndSort;
      this.initialLoad = true;
      this.nextPage = 0;
      this.loadBewertungen();
    }
  }

}

if (!customElements.get("bewertungen-artikeldetail-overlay")) {
  customElements.define("bewertungen-artikeldetail-overlay", BewertungenArtikeldetailOverlay);
}
